import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  Stack,
} from "@mui/material";
import moment from "moment";


export default function RemoveConfirmation(props) {
  const { open, removeItem, removeItemFuncConfirm, removeBillingStatementItem, removeBillingPeriodName, removeItemBillingStartDate, removeItemBillingEndDate, removeBrokerName  } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
   const startDate = moment(removeItemBillingStartDate).format("MM/DD/YYYY")
   const enddate = moment(removeItemBillingEndDate).format("MM/DD/YYYY")

   console.log(removeItem,'removeeeeeeeeee')
  return (
    <>
     
      <Dialog
        className="user-filter-popup user-filter"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        //onClose={""}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "26px 34px" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Typography className="model-title">Remove Confirmation</Typography>
        </Stack>
        <Box sx={{ p: "0px 34px 0px 34px" }}>

          { removeBillingStatementItem ? 
          <p className="label">Are you sure you want to remove statement ID: "{removeBillingStatementItem}" for the broker: "{removeBrokerName}" ?</p>
          : 
          <p className="label">
          {`Are you sure you want to remove this Project: "${removeBillingPeriodName} (${startDate} - ${enddate})"?`}
         </p>        
          }
        
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 34px", mt: "21px" }}
        >

          { removeBillingStatementItem ? 
          <Button className="filter-btn" onClick={()=>{ removeItemFuncConfirm({removeItem: removeItem, removeBillingStatementItem: removeBillingStatementItem },"statementId");}}>Yes
          </Button>
          : 
          <Button className="filter-btn" onClick={()=>{ removeItemFuncConfirm({removeItem: removeItem}, "statementRow")}}>Yes
          </Button>
          }
          <Button className="cancel-btn" onClick={removeItemFuncConfirm}>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
